import { createContext } from 'react'

/**
 * Whether a `ScreenActions` below may draw its buttons. True everywhere except
 * inside a hidden `KeptView`, which keeps a view mounted while another shows,
 * so that only the showing view's tools reach the header cluster.
 */
export const ScreenActionsEnabled = createContext(true)
